import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { AccordionModule } from 'primeng/accordion';
import { TabViewCloseEvent, TabViewModule } from 'primeng/tabview';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { LucideAngularModule, CirclePlusIcon } from 'lucide-angular';
import { BaseComponent } from '@src/app/components';

import { DatasourceFormDataType } from '../datasource-form';

import { FormType } from './types';
import {
  DatasourceFormComponent,
  MappingFormComponent,
  ParamFormComponent,
  UIFormComponent,
  UIFormDataType,
  createParamForm,
} from './components';

@Component({
  selector: 'filter-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DropdownModule,
    InputTextModule,
    InputNumberModule,
    InputSwitchModule,
    AccordionModule,
    TabViewModule,
    ButtonModule,
    TooltipModule,
    LucideAngularModule,
    DatasourceFormComponent,
    MappingFormComponent,
    ParamFormComponent,
    UIFormComponent,
  ],
  templateUrl: './filter-form.component.html',
  styleUrl: './filter-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterFormComponent extends BaseComponent {
  private readonly confirmationService = inject(ConfirmationService);

  @Input() form!: FormGroup<FormType>;
  @Input() loading = false;
  @Input() otherFilters?: UIFormDataType[];
  @Input() datasourceCopyData?: DatasourceFormDataType;

  readonly types = [];
  readonly CirclePlusIcon = CirclePlusIcon;

  formsActiveIndex?: number;
  paramsActiveIndex = 0;

  get paramsControl() {
    return this.form.controls.params;
  }

  addParamControl() {
    this.paramsControl.push(createParamForm());

    this.moveTab(this.paramsControl.controls.length);
  }

  private removeParamControl(index: number) {
    this.paramsControl.removeAt(index);

    this.moveTab(index);
  }

  closeTab(event: TabViewCloseEvent) {
    this.confirmationService.confirm({
      message: 'Вы действительно хотите удалить эту вкладку?',
      header: 'Подтверждение удаления',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      accept: () => {
        this.removeParamControl(event.index);
        event.close?.();
      },
    });
  }

  private moveTab(index: number) {
    setTimeout(() => {
      this.paramsActiveIndex = index > 0 ? index - 1 : 0;
      this.cdr.markForCheck();
    }, 300);
  }
}
